// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"36":"db9b083934064219","829":"5821252d7abc26a7"}[chunkId] + ".css";
};